'use server'

import { apiRequest, ApiResponse } from '../request'

export interface CreateSubscriptionInput {
    organizationId: number
    planId: number
    dueDay?: number
}

export async function createSubscription(
    data: CreateSubscriptionInput,
): Promise<ApiResponse<any>> {
    return apiRequest<any>('subscriptions', { data }, 'post')
}

export async function getSubscriptionByCompany(
    companyId: number,
): Promise<ApiResponse<any>> {
    return apiRequest<any>(`subscriptions/company/${companyId}`, {})
}
